import { render, staticRenderFns } from "./ClientesComponent.vue?vue&type=template&id=faf4c584&scoped=true"
import script from "./ClientesComponent.vue?vue&type=script&lang=js"
export * from "./ClientesComponent.vue?vue&type=script&lang=js"
import style0 from "./ClientesComponent.vue?vue&type=style&index=0&id=faf4c584&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faf4c584",
  null
  
)

export default component.exports